import { Box, useTheme } from "@mui/material";
import { Card } from "v2/components/base/Flex/ui";

const ModalContainerUI = (props: any) => {
  const theme = useTheme();
  const { sx, ...rest } = props;
  return (
    <Card.Section
      sx={{
        position: "relative",
        border: `1px solid #FFFFFF0D`,
        padding: "20px",
        "&:focus-visible": {
          outline: "none",
        },
        background: theme.palette.surface["container-bg"],
        ...sx,
      }}
      {...rest}>
      {props.children}
    </Card.Section>
  );
};

export default ModalContainerUI;
